
/**
 * @group Configuration
 */
export type TMarginConfiguration = {
  bottom: number
  left: number
  right: number
  top: number
}

/**
 * @group Configuration
 */
export const DefaultMarginConfiguration: TMarginConfiguration = {
  top: 20,
  left: 10,
  right: 10,
  bottom: 10
}
